module.exports = __webpack_public_path__ + "img/diy.0807f4b8.png";